import { Component } from '@angular/core';
import { RightPanelService } from '../core/services/right-panel.service';
import { RightPanelType } from '../core/enums/right-panel-type.enum';
import { InlineSVGComponent } from '../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { UserInfoComponent } from '../shared/components/user-info/user-info.component';
import { RedactTicketComponent } from './redact-ticket/redact-ticket.component';
import { HideTicketContentComponent } from './hide-ticket-content/hide-ticket-content.component';
import { VoyadoComponent } from './voyado/voyado.component';
import { GroupInfoComponent } from './group-info/group-info.component';

@Component({
    selector: 'app-right-panel',
    templateUrl: './right-panel.component.html',
    styleUrls: ['./right-panel.component.scss'],
    imports: [
        InlineSVGComponent,
        UserInfoComponent,
        RedactTicketComponent,
        HideTicketContentComponent,
        VoyadoComponent,
        GroupInfoComponent,
    ],
})
export class RightPanelComponent {
    rightPanelTypeEnum = RightPanelType;

    constructor(public rightPanelService: RightPanelService) {}
}
